import "core-js/modules/es6.reflect.construct.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["maxButtons", "boundaryLinks", "ellipsis", "first", "last", "prev", "next", "onSelect", "buttonComponentClass", "noBorder", "className", "clsPrefix", "size", "gap", "onDataNumSelect", "dataNumSelect", "activePage", "itemRender", "showJump", "total", "disabled", "btnType", "confirmBtn", "showTotal", "showTitle", "hideOnSinglePage", "showSizeChanger", "locale", "simple"];

var _dec, _class;

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.number.is-nan.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classnames from "classnames";
import React from "react";
import PaginationButton from "./PaginationButton";
import Select from '../../wui-select/src';
import Icon from '../../wui-icon/src';
import assign from 'object-assign';
import cookie from 'react-cookies';
import PropTypes from "prop-types";
import i18n from './i18n';
import { getComponentLocale } from '../../wui-locale/src/tool';
import omit from 'omit.js';
import { WebUI } from "../../wui-core/src/index.js";
var Option = Select.Option;
var propTypes = {
  /**
   * 当前激活状态页
   */
  activePage: PropTypes.number,

  /**
   * 指定分页数量
   */
  pageSize: PropTypes.number,

  /**
   * 默认分页数量
   */
  defaultPageSize: PropTypes.number,

  /**
   * 总页数
   */
  items: PropTypes.number,

  /**
   * 显示按钮从1到maxButton的按钮数
   */
  maxButtons: PropTypes.number,

  /**
   * 当为true,不管切换到多少页都显示第一页和最后一页的按钮
   */
  boundaryLinks: PropTypes.bool,

  /**
   * 当为true,显示省略号，否则
   *
   */
  ellipsis: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   *  当为true,显示点击到第一页的按钮
   */
  first: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   *  当为true,显示点击到最后一页的按钮
   */
  last: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   * 当为true,显示前一页按钮
   */
  prev: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   * 当为true,显示下一页按钮
   */
  next: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   * 暴露给用户的切换页的方法
   */
  onSelect: PropTypes.func,

  /**
   * You can use a custom element for the buttons
   */
  buttonComponentClass: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /**
   * 每页多少条的选择
   */
  dataNumSelect: PropTypes.array,

  /**
   * 每页多少条选择哪一个
   */
  dataNum: PropTypes.number,

  /**
   * 显示跳页
   */
  showJump: PropTypes.bool,

  /**
   * 显示总共条数
   */
  total: PropTypes.number,

  /**
   *  pagiantion不可点
   */
  disabled: PropTypes.bool,

  /**
   *  确认按钮的样式集合
   */
  btnType: PropTypes.object,

  /**
   *  渲染确认按钮的dom
   */
  confirmBtn: PropTypes.func,

  /**
   * 通过cookie来确定分页的size,需设定唯一的key值
   */
  sizeWithCookie: PropTypes.string,

  /**
   * 默认的当前页数
   */
  defaultActivePage: PropTypes.number,

  /**
   * 默认的每页条数
   */
  defaultDataNum: PropTypes.number,

  /**
   * 只有一页时是否隐藏分页器
   */
  hideOnSinglePage: PropTypes.bool,

  /**
   * 当 size 未指定时，根据屏幕宽度自动调整尺寸
   */
  responsive: PropTypes.bool,

  /**
   * 通是否展示pageSize切换器
   */
  showSizeChanger: PropTypes.bool,

  /**
   * 用于自定义页码的结构
   */
  itemRender: PropTypes.func,

  /**
   * 是否显示原生 tooltip 页码提示
   */
  showTitle: PropTypes.bool,

  /**
   * 用于自定义页码的结构
   */
  showTotal: PropTypes.bool,

  /**
   * 用于自定义页码的结构
   */
  simple: PropTypes.bool
};
var defaultProps = {
  activePage: 1,
  defaultActivePage: 1,
  defaultPageSize: 10,
  items: 0,
  maxButtons: 5,
  boundaryLinks: true,
  ellipsis: true,
  first: true,
  last: true,
  prev: true,
  next: true,
  onSelect: function onSelect() {},
  dataNumSelect: [],
  showJump: true,
  total: 0,
  disabled: false,
  btnType: {
    shape: 'border'
  },
  confirmBtn: function confirmBtn() {},
  dataNum: null,
  sizeWithCookie: '',
  defaultDataNum: 10,
  hideOnSinglePage: false,
  responsive: false,
  showSizeChanger: false,
  showTitle: true,
  gap: true,
  noBorder: true,
  locale: 'zh-cn',
  size: 'sm',
  showTotal: false
};
var Pagination = (_dec = WebUI({
  name: "pagination",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination(props, context) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "onKeyup", function (e) {
      e.keyCode === 13 && _this.handleEnsurePageJump();
    });

    _defineProperty(_assertThisInitialized(_this), "setPageJump", function (e) {
      var value = e.target.value; // 20181129跳转内容可以清空

      if (value !== '' && (isNaN(Number(value)) || value > _this.state.items || value <= 0)) {
        return false;
      } else {
        _this.setState({
          jumpPageState: value === '' ? '' : parseInt(value)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnsurePageJump", function () {
      var _this$props = _this.props,
          dataNumSelect = _this$props.dataNumSelect,
          pageSize = _this$props.pageSize,
          simple = _this$props.simple;
      var _this$state = _this.state,
          jumpPageState = _this$state.jumpPageState,
          dataNum = _this$state.dataNum;
      var onSelect = _this.props.onSelect;

      if (jumpPageState === '') {
        return;
      }

      if (simple) {
        _this.setState({
          activePage: jumpPageState * 1
        });
      } else {
        _this.setState({
          activePage: jumpPageState * 1,
          jumpPageState: ''
        });
      }

      if (typeof onSelect === 'function') {
        onSelect(jumpPageState * 1, pageSize || dataNumSelect[dataNum]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dataNumSelect", function (value) {
      var _this$props2 = _this.props,
          onDataNumSelect = _this$props2.onDataNumSelect,
          total = _this$props2.total,
          pageSize = _this$props2.pageSize,
          dataNumSelect = _this$props2.dataNumSelect;
      var activePage = _this.state.activePage;
      var dataNumValue = dataNumSelect[value];

      if (pageSize) {
        // 如果存在pageSize 下拉框无效
        return onDataNumSelect && onDataNumSelect(activePage, Number(dataNumValue));
      }

      if (total) {
        _this.setState({
          items: Number.isNaN(parseInt(dataNumValue)) ? 1 : Math.ceil(total / dataNumValue)
        });

        if (activePage > Math.ceil(total / dataNumValue)) {
          activePage = Math.ceil(total / dataNumValue);

          _this.setState({
            activePage: activePage
          });
        }
      }

      _this.setState({
        dataNum: value
      });

      if (typeof onDataNumSelect === 'function') {
        onDataNumSelect(activePage, Number(dataNumValue));
      }
    });

    var _dataNum = props.dataNum;
    var _simple = props.simple;
    _this.state = {
      activePage: _this.props.activePage || _this.props.defaultActivePage,
      //当前的页码
      dataNum: _dataNum,
      items: props.items ? props.items : props.total ? Math.ceil(props.total / props.dataNumSelect[_dataNum]) : 1,
      jumpPageState: _simple ? _this.props.activePage : ''
    };
    _this.pagination = {};
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var activePage = nextProps.activePage,
          dataNum = nextProps.dataNum,
          dataNumSelect = nextProps.dataNumSelect,
          total = nextProps.total,
          simple = nextProps.simple;

      if (activePage && this.state.activePage !== activePage) {
        this.setState({
          activePage: activePage
        });
      }

      if ((dataNum === 0 || dataNum) && this.state.dataNum !== dataNum) {
        this.setState({
          dataNum: dataNum,
          // 20181210因为dataNumSelect的某项不是数字或者数字字符串
          items: Number.isNaN(parseInt(dataNumSelect[dataNum])) ? 1 : Math.ceil(total / parseInt(dataNumSelect[dataNum]))
        });
      }

      if (simple && this.state.jumpPageState !== activePage) {
        this.setState({
          jumpPageState: activePage
        });
      } // if ('items' in nextProps && this.props.items !== items) {
      //     let newItems = items === 0 ? 1 : items;
      //     this.setState({
      //         items: newItems,
      //     })
      // }


      if ('total' in nextProps && this.props.total !== total) {
        var pageSize = nextProps.pageSize || parseInt(dataNumSelect[dataNum]);
        this.setState({
          items: Math.ceil(total / pageSize)
        });
      }
    }
  }, {
    key: "renderPageButtons",
    value:
    /**
     * 渲染page的按钮
     * @param activePage
     * @param items
     * @param maxButtons
     * @param boundaryLinks
     * @param ellipsis
     * @param buttonProps
     * @returns {Array}
     */
    function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
      var _this$props3 = this.props,
          showTitle = _this$props3.showTitle,
          itemRender = _this$props3.itemRender,
          pageSize = _this$props3.pageSize,
          dataNumSelect = _this$props3.dataNumSelect;
      var dataNum = this.state.dataNum;
      var pageButtons = [];
      var startPage;
      var endPage;
      var hasHiddenPagesAfter;

      if (maxButtons) {
        //根据max很当前activepage计算出应隐藏activeButton之前的页数
        var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
        startPage = hiddenPagesBefore >= 2 ? hiddenPagesBefore : 1; //计算出是否存在隐藏activeButton之后的页数

        hasHiddenPagesAfter = startPage + maxButtons < items + 1;

        if (!hasHiddenPagesAfter) {
          endPage = items;
          startPage = items - maxButtons + 1;

          if (startPage < 1) {
            startPage = 1;
          }
        } else {
          endPage = startPage + maxButtons - 1;
        }
      } else {
        startPage = 1;
        endPage = items;
      } //将所有的button循环渲染出来


      for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
        pageButtons.push( /*#__PURE__*/React.createElement(PaginationButton, _extends({}, buttonProps, {
          key: pagenumber,
          type: 'page',
          pageSize: pageSize || dataNumSelect[dataNum],
          itemRender: itemRender,
          eventKey: pagenumber,
          active: pagenumber === activePage,
          showTitle: showTitle,
          title: pagenumber
        }), pagenumber));
      } //如果boundaryLinks和eclipsis且startPage!=1 需要加上before More Button


      if (boundaryLinks && ellipsis && startPage !== 1) {
        if (startPage > 2) {
          pageButtons.unshift( /*#__PURE__*/React.createElement(PaginationButton, {
            key: "ellipsisFirst",
            disabled: true,
            pageSize: pageSize || dataNumSelect[dataNum],
            itemRender: itemRender,
            componentClass: buttonProps.componentClass,
            className: "".concat(this.props.clsPrefix, "-item-ellipsis"),
            showTitle: showTitle
          }, /*#__PURE__*/React.createElement("span", {
            "aria-label": "More"
          }, ellipsis === true ? "\u2026" : ellipsis)));
        } //加上最小边界 Button


        pageButtons.unshift( /*#__PURE__*/React.createElement(PaginationButton, _extends({
          title: 1,
          itemRender: itemRender,
          pageSize: pageSize || dataNumSelect[dataNum],
          showTitle: showTitle
        }, buttonProps, {
          key: 1,
          eventKey: 1,
          active: false
        }), "1"));
      } //如果maxButtons和eclipsis且hasHiddenPagesAfter 需加上after More Button


      if (maxButtons && hasHiddenPagesAfter && ellipsis) {
        if (!boundaryLinks || boundaryLinks && items > 1 + endPage) {
          pageButtons.push( /*#__PURE__*/React.createElement(PaginationButton, {
            key: "ellipsis",
            disabled: true,
            pageSize: pageSize || dataNumSelect[dataNum],
            itemRender: itemRender,
            componentClass: buttonProps.componentClass,
            className: "".concat(this.props.clsPrefix, "-item-ellipsis"),
            showTitle: showTitle
          }, /*#__PURE__*/React.createElement("span", {
            "aria-label": "More"
          }, ellipsis === true ? "\u2026" : ellipsis)));
        } //如果最后一个页数按钮不等于总页数 且 边界为true 需加上最大边界按钮


        if (boundaryLinks && endPage !== items) {
          pageButtons.push( /*#__PURE__*/React.createElement(PaginationButton, _extends({}, buttonProps, {
            itemRender: itemRender,
            key: items,
            eventKey: items,
            type: 'page',
            active: false,
            pageSize: pageSize || dataNumSelect[dataNum],
            title: items,
            showTitle: showTitle
          }), items));
        }
      }

      return pageButtons;
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props4 = this.props,
          maxButtons = _this$props4.maxButtons,
          boundaryLinks = _this$props4.boundaryLinks,
          ellipsis = _this$props4.ellipsis,
          first = _this$props4.first,
          last = _this$props4.last,
          prev = _this$props4.prev,
          next = _this$props4.next,
          onSelect = _this$props4.onSelect,
          buttonComponentClass = _this$props4.buttonComponentClass,
          noBorder = _this$props4.noBorder,
          className = _this$props4.className,
          clsPrefix = _this$props4.clsPrefix,
          size = _this$props4.size,
          gap = _this$props4.gap,
          onDataNumSelect = _this$props4.onDataNumSelect,
          dataNumSelect = _this$props4.dataNumSelect,
          activePage = _this$props4.activePage,
          itemRender = _this$props4.itemRender,
          showJump = _this$props4.showJump,
          total = _this$props4.total,
          disabled = _this$props4.disabled,
          btnType = _this$props4.btnType,
          confirmBtn = _this$props4.confirmBtn,
          showTotal = _this$props4.showTotal,
          showTitle = _this$props4.showTitle,
          hideOnSinglePage = _this$props4.hideOnSinglePage,
          showSizeChanger = _this$props4.showSizeChanger,
          locale = _this$props4.locale,
          simple = _this$props4.simple,
          others = _objectWithoutProperties(_this$props4, _excluded);

      var local = i18n[locale] || {};
      var _this$state2 = this.state,
          dataNum = _this$state2.dataNum,
          jumpPageState = _this$state2.jumpPageState;
      var pageSize = this.props.pageSize || dataNumSelect[dataNum];
      var activePageState = this.state.activePage;
      var items = this.state.items;
      var btnDom = confirmBtn(assign({}, this.props));
      var classes = {};

      if (noBorder) {
        classes["".concat(clsPrefix, "-no-border")] = true;
      }

      if (size) {
        classes["".concat(clsPrefix, "-").concat(size)] = true;
      }

      if (!noBorder && gap) {
        classes["".concat(clsPrefix, "-gap")] = true;
      }

      if (!!btnDom) {
        classes["".concat(clsPrefix, "-with-jumpbtn")] = true;
      }

      var classNames = classnames("".concat(clsPrefix, "-list"), classes);
      var wrapperClass = classnames(clsPrefix, (_classnames = {}, _defineProperty(_classnames, "".concat(clsPrefix, "-simple"), simple), _defineProperty(_classnames, "".concat(clsPrefix, "-disabled"), disabled), _classnames));
      /**
       *  页按钮属性
       *  onSelect:暴露在外层交互动作，也是与父组件Pagination的交流接口
       *  componentClass: 用户定义的按钮dom元素类型
       */

      var buttonProps = {
        onSelect: function onSelect(eventKey, pageSize, event) {
          _this2.setState({
            activePage: event
          });

          _this2.props.onSelect && _this2.props.onSelect(eventKey, pageSize, event);
        },
        pageSize: pageSize,
        itemRender: itemRender,
        componentClass: buttonComponentClass
      };
      var jumpBtn = btnDom ? /*#__PURE__*/React.createElement("div", {
        className: "page_jump_btn",
        onClick: this.handleEnsurePageJump
      }, btnDom) : null;

      if (hideOnSinglePage && items === 1) {
        return null;
      }

      if (simple) {
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(wrapperClass, className),
          ref: function ref(e) {
            return _this2.pagination = e;
          }
        }, /*#__PURE__*/React.createElement("ul", _extends({}, omit(others, ['dataNum', 'sizeWithCookie', "defaultActivePage", "pageSize", "defaultPageSize", "defaultDataNum", "responsive"]), {
          className: classNames
        }), /*#__PURE__*/React.createElement(PaginationButton, _extends({
          type: 'prev'
        }, buttonProps, {
          eventKey: activePageState - 1,
          disabled: activePageState === 1,
          pageSize: pageSize,
          iconBtn: true,
          simple: simple,
          className: "".concat(clsPrefix, "-prev-simple"),
          showTitle: showTitle,
          title: '上一页'
        }), /*#__PURE__*/React.createElement(Icon, {
          type: "uf-arrow-left"
        })), /*#__PURE__*/React.createElement("div", {
          className: "page_jump page_jump_simple"
        }, /*#__PURE__*/React.createElement("input", {
          className: "page_jump_value page_jump_value_simple",
          value: jumpPageState,
          onKeyDown: this.onKeyup,
          onBlur: this.handleEnsurePageJump,
          onChange: this.setPageJump
        }), /*#__PURE__*/React.createElement("span", null, "/ ", Math.ceil(total / pageSize))), /*#__PURE__*/React.createElement(PaginationButton, _extends({
          type: 'next',
          simple: simple
        }, buttonProps, {
          eventKey: activePageState + 1,
          disabled: activePageState >= this.state.items,
          iconBtn: true,
          className: "".concat(clsPrefix, "-next-simple"),
          showTitle: showTitle,
          title: '下一页'
        }), /*#__PURE__*/React.createElement(Icon, {
          type: "uf-arrow-right"
        }))));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classnames(wrapperClass, className),
        ref: function ref(e) {
          return _this2.pagination = e;
        }
      }, disabled && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-disabled-mask")
      }), /*#__PURE__*/React.createElement("ul", _extends({}, omit(others, ['dataNum', 'sizeWithCookie', "defaultActivePage", "pageSize", "defaultPageSize", "defaultDataNum", "responsive"]), {
        className: classNames
      }), first && /*#__PURE__*/React.createElement(PaginationButton, _extends({}, buttonProps, {
        eventKey: 1,
        disabled: activePageState === 1,
        iconBtn: true,
        pageSize: pageSize,
        className: "".concat(clsPrefix, "-first"),
        showTitle: showTitle,
        title: '返回首页'
      }), /*#__PURE__*/React.createElement(Icon, {
        type: "uf-2arrow-left"
      })), prev && /*#__PURE__*/React.createElement(PaginationButton, _extends({
        type: 'prev'
      }, buttonProps, {
        eventKey: activePageState - 1,
        disabled: activePageState === 1,
        pageSize: pageSize,
        iconBtn: true,
        className: "".concat(clsPrefix, "-prev"),
        showTitle: showTitle,
        title: '上一页'
      }), /*#__PURE__*/React.createElement(Icon, {
        type: "uf-arrow-left"
      })), this.renderPageButtons(activePageState, this.state.items, maxButtons, boundaryLinks, ellipsis, buttonProps), next && /*#__PURE__*/React.createElement(PaginationButton, _extends({
        type: 'next'
      }, buttonProps, {
        eventKey: activePageState + 1,
        disabled: activePageState >= this.state.items,
        iconBtn: true,
        className: "".concat(clsPrefix, "-next"),
        showTitle: showTitle,
        title: '下一页'
      }), /*#__PURE__*/React.createElement(Icon, {
        type: "uf-arrow-right"
      })), last && /*#__PURE__*/React.createElement(PaginationButton, _extends({}, buttonProps, {
        type: 'last',
        eventKey: this.state.items,
        disabled: activePageState >= this.state.items,
        iconBtn: true,
        className: "".concat(clsPrefix, "-last"),
        showTitle: showTitle,
        title: '跳至尾页'
      }), /*#__PURE__*/React.createElement(Icon, {
        type: "uf-2arrow-right"
      }))), showTotal ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-total")
      }, showTotal(total, activePage > 1 ? [(activePage - 1) * pageSize, activePage * pageSize] : [0, activePage * pageSize])) : total != null ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-total")
      }, local['total'], /*#__PURE__*/React.createElement("span", null, total), local['items']) : null, showJump && showSizeChanger ? /*#__PURE__*/React.createElement("div", {
        className: "data_per_select"
      }, /*#__PURE__*/React.createElement(Select, {
        getPopupContainer: function getPopupContainer() {
          return _this2.pagination;
        },
        dropdownClassName: "".concat(clsPrefix, "-data_per_select"),
        value: this.state.dataNum,
        onChange: this.dataNumSelect
      }, dataNumSelect.length > 0 && dataNumSelect.map(function (item, i) {
        return /*#__PURE__*/React.createElement(Option, {
          key: i,
          value: i
        }, item);
      })), /*#__PURE__*/React.createElement("span", null, local['items'])) : null, showJump ? /*#__PURE__*/React.createElement("div", {
        className: "page_jump"
      }, /*#__PURE__*/React.createElement("span", null, local['goto']), /*#__PURE__*/React.createElement("input", {
        className: "page_jump_value",
        value: jumpPageState,
        onKeyDown: this.onKeyup,
        onBlur: this.handleEnsurePageJump,
        onChange: this.setPageJump
      }), /*#__PURE__*/React.createElement("span", null, local['page']), jumpBtn) : null);
    }
  }]);

  return Pagination;
}(React.Component)) || _class);
Pagination.propTypes = propTypes;
Pagination.contextTypes = {
  beeLocale: PropTypes.object
};
export default Pagination;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-pagination/src/Pagination.js